import React, { useEffect, useRef } from 'react';
import TopographicMapFull from './TopographicMapFull';

/**
 * TacticalHero - Hero cinematográfico con mapa topográfico realista
 * Basado en prototipo: mapa completo, parallax, narrativa militar coherente
 */
const TacticalHero = ({ onNavigate }) => {
  const heroRef = useRef(null);
  const mapParallaxRef = useRef(null);

  useEffect(() => {
    const hero = heroRef.current;
    const mapParallax = mapParallaxRef.current;

    if (!hero || !mapParallax) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const coarsePointer = window.matchMedia('(pointer: coarse)').matches;

    if (reduceMotion || coarsePointer) return;

    let frame = 0;

    const handlePointerMove = (event) => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const rect = hero.getBoundingClientRect();
        const nx = (event.clientX - rect.left) / rect.width - 0.5;
        const ny = (event.clientY - rect.top) / rect.height - 0.5;
        const px = (-nx * 7).toFixed(2);
        const py = (-ny * 5).toFixed(2);
        mapParallax.style.transform = `translate3d(${px}px, ${py}px, 0)`;
      });
    };

    const handlePointerLeave = () => {
      mapParallax.style.transform = 'translate3d(0px, 0px, 0)';
    };

    hero.addEventListener('pointermove', handlePointerMove);
    hero.addEventListener('pointerleave', handlePointerLeave);

    return () => {
      hero.removeEventListener('pointermove', handlePointerMove);
      hero.removeEventListener('pointerleave', handlePointerLeave);
      cancelAnimationFrame(frame);
    };
  }, []);

  const scrollToSection = (section) => {
    if (onNavigate) {
      onNavigate(section);
    } else {
      const element = document.getElementById(section);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <section className="tactical-hero-full" ref={heroRef}>
      {/* Map parallax layer */}
      <div className="map-parallax" ref={mapParallaxRef} aria-hidden="true">
        <div className="map-camera">
          <TopographicMapFull />
        </div>
      </div>

      {/* Atmospheric layers */}
      <div className="content-shade" aria-hidden="true" />
      <div className="vignette-full" aria-hidden="true" />
      <div className="grain-full" aria-hidden="true" />

      {/* Hero content */}
      <section className="hero-content-full">
        <div className="copy-full">
          <p className="eyebrow-full">01 / Unidad de simulación militar latina</p>
          <h1 className="title-full">Operar con propósito</h1>
          <p className="lede-full">
            Unidad MILSIM de Enfusion (Reforger/Arma4) enfocada en coordinación, entrenamiento progresivo y operaciones combinadas.
          </p>

          <div className="actions-full">
            <button
              className="btn-full primary-full"
              onClick={() => scrollToSection('contact')}
            >
              Solicitar ingreso
            </button>
            <button
              className="btn-full secondary-full"
              onClick={() => scrollToSection('about')}
            >
              Explorar operaciones
            </button>
          </div>

          <div className="ops-meta-full">
            <span className="status-full">DEPLOYED</span>
            <span className="dotsep-full">·</span>
            <span>Operación en curso:</span>
            <span className="meta-accent-full">USMLOPS FAIRCROFT</span>
          </div>
        </div>
      </section>

      {/* Map caption */}
      <div className="map-caption-full">
        CENTCOM 20-27 / USMLOPS
      </div>
    </section>
  );
};

export default TacticalHero;
